import createVueComponent from '../createVueComponent';

const Goal = createVueComponent('GoalIcon', [
  ['path', { d: 'M12 13V2l8 4-8 4', key: '5wlwwj' }],
  ['path', { d: 'M20.55 10.23A9 9 0 1 1 8 4.94', key: '5988i3' }],
  ['path', { d: 'M8 10a5 5 0 1 0 8.9 2.02', key: '1hq7ot' }],
]);

export default Goal;
